import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/preview/zipRenderer/nodes/node/styles.scss';export default {
  "node": "_node_10ib4_1",
  "iconBox": "_iconBox_10ib4_8",
  "icon": "_icon_10ib4_8",
  "name": "_name_10ib4_20"
};